module.exports = __webpack_public_path__ + "img/ctit.d23dce6b.svg";